import React, { Component } from 'react'
import style from './style.module.less'
import { observer, inject } from 'mobx-react'
import { Modal } from 'hljd'
import {
  PATH_ZTB_INTRO,
  GET_EXTRA_NUMBER,
  PROMOTE_STATUS
} from '@components/LocalMerchant/ZhiTuiBao/constant'
import { Link } from 'react-router'
import Panel from '@common/Panel'
import { Flex } from 'hljd'
import { buyZhiTuiBao } from '../../util'
import cls from 'classnames'

const Data = ({ title, number, btn }) => {
  return (
    <Flex
      className={cls('text-center', style.board)}
      d="v"
      vc
      style={{ flexBasis: '22%' }}
    >
      <div className={style.title}>{title}</div>
      <div className={style.number}>{number}</div>

      {btn && <div>{btn}</div>}
    </Flex>
  )
}

const Text = ({ title, text, btn }) => {
  return (
    <Flex
      className={cls('text-center', style.board)}
      d="v"
      vc
      style={{ flexBasis: '34%' }}
    >
      <div className={style.title}>{title}</div>
      <div className={style.text}>{text}</div>

      {btn && <div>{btn}</div>}
    </Flex>
  )
}

@inject('pageStore')
@observer
export default class extends Component {
  buy = can_buy_packet => {
    if (can_buy_packet == '1') {
      buyZhiTuiBao()
    }
  }
  render() {
    const {
      pageData: {
        now_use_num,
        prepare_use_num,
        extra_flow_percent,
        promote_status,
        can_buy_packet
      },
      showGetExtraBtn,
      showDelivery,
      tabsStore: { changeToPackageTab }
    } = this.props.pageStore
    const x = 10 + now_use_num - 2

    return (
      <Panel title="智推宝" extra={<Link to={PATH_ZTB_INTRO}>产品介绍</Link>}>
        <Flex className={style.content} vc>
          <Text
            title="投放状态"
            text={PROMOTE_STATUS[promote_status]}
            btn={
              <div
                className={cls(style.btn, style.orange)}
                onClick={showDelivery}
              >
                切换投放方式
              </div>
            }
          />
          <Data
            title="正在使用套包"
            number={now_use_num || 0}
            btn={
              <div className={style.btn} onClick={changeToPackageTab}>
                激活提升流量
              </div>
            }
          />
          <Data
            title="待激活套包"
            number={prepare_use_num || 0}
            btn={
              <div
                className={cls(style.btn, {
                  [style.orange]: can_buy_packet == '1',
                  [style.disabled]: can_buy_packet == '0'
                })}
                onClick={() => this.buy(can_buy_packet)}
              >
                购买套包
              </div>
            }
          />
          <Data
            title="额外获赠流量"
            number={`${extra_flow_percent || 0}%`}
            btn={
              showGetExtraBtn ? (
                <div
                  className={cls(style.btn, style.orange)}
                  onClick={() => {
                    Modal.confirm({
                      title: '无法获得额外流量',
                      content: `正在使用的智推宝套包数量不足${GET_EXTRA_NUMBER}个，请购买并激活更多的智推宝套包`,
                      okText: '立即激活',
                      cancelText: '遗憾放弃',
                      onOk: () => {
                        changeToPackageTab()
                      }
                    })
                  }}
                >
                  10%额外流量
                </div>
              ) : (
                <div
                  className={cls(style.btn, style.orange)}
                  onClick={() => {
                    Modal.confirm({
                      title: '是否立即激活1个智推宝',
                      content: `激活后获得的额外流量将提升到${x}%`,
                      okText: '立即激活',
                      cancelText: '遗憾放弃',
                      onOk: () => {
                        changeToPackageTab()
                      }
                    })
                  }}
                >
                  提升至{x}%
                </div>
              )
            }
          />
        </Flex>
      </Panel>
    )
  }
}
